import {Pipe, Injectable, PipeTransform} from '@angular/core'
import Fuse from 'fuse.js'

@Pipe({
  name: 'fuzzySearch',
  pure: false
})
@Injectable()
export class FuzzySearchPipe implements PipeTransform {

  transform(items: any[], args: {
    searchString?: string;
    keys?: any[],
    threshold?: number,
    shouldSort?: boolean
  }): any {

    // If there the searchString is falsy, return all the items
    if (!args['searchString']) return items

    const threshold = args.threshold || 0.2
    const searchString = args.searchString || ''
    const keys = args.keys || []
    const shouldSort = args.shouldSort || false

    let options = {
      keys,
      threshold,
      shouldSort
    }

    const fuse = new Fuse(items, <Fuse.FuseOptions<any>>options)
    const results = fuse.search(searchString)
    return results
  }
}
export default FuzzySearchPipe
